import React from "react";
import Fox from "../../assets/Fox.svg";

export default function FoxIcon({ size }) {
  return <img src={Fox} width={size} />;
}
